<template>
  <div>
    <v-fade-transition>
      <crud-detail
        :update-mode="updateMode"
        :showButton="false"
        class="mt-2"
        :next="next"
        :modalLeave="modalLeave"
        @closeLeave="modalLeave = false"
      >
        <headers-detail>
          <v-btn
            v-if="
              this.updateMode &&
              roleCorrespondant == true &&
              form.canSave == true
            "
            dark
            @click="customSave"
            color="redExtraciem"
          >
            {{ $t('button.save') }}
          </v-btn>

          <v-btn
            color="success"
            v-if="
              this.updateMode &&
              roleCorrespondant == true &&
              form.canSave == true
            "
            v-on:click="dialogPassword = true"
            class="ml-2"
          >
            <v-icon left> mdi-form-textbox-password </v-icon>
            {{ $t('password.changeButton') }}</v-btn
          >
        </headers-detail>

        <v-dialog v-model="this.dialogPassword" persistent max-width="50%">
          <v-form ref="passwordForm">
            <v-card>
              <v-card-title class="info white--text">
                {{ $t('password.changeButton') }}
              </v-card-title>

              <v-card-text class="body-1">
                <br />
                <v-text-field
                  v-model="ancienMotDePasse"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  filled
                  dense
                  :rules="[obligatoireRule(), serveurRule('ancienMotDePasse')]"
                  :type="show1 ? 'text' : 'password'"
                  :label="$t('password.changeDialog.oldPassword')"
                  @click:append="show1 = !show1"
                />
                <passwordForm
                  @emitPassword="emitPassword"
                  @emitConfirmation="emitConfirmation"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="changePassword">
                  {{ $t('button.save') }}
                </v-btn>
                <v-btn text @click="cancelPassword">
                  {{ $t('button.cancel') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-layout row :class="'pr-2 pl-2 pt-3'">
          <!-- informations participant (gauche) -->

          <v-flex md11>
            <v-layout row>
              <v-flex md6>
                <v-text-field
                  :value="id"
                  :label="$t('correspondant.details.id')"
                  readonly
                  disabled
                />
              </v-flex>
            </v-layout>
            <v-card class="specific">
              <v-card-title class="headerCardIndigo white--text">
                <v-icon dark>mdi-contacts</v-icon>
                <span style="margin-left: 5px">{{
                  $t('correspondant.details.contact')
                }}</span>
              </v-card-title>
              <v-layout row class="ma-2 pa-1">
                <v-flex md12>
                  <v-layout row>
                    <v-flex md4>
                      <enum-entity-field
                        namespace="civilite"
                        v-model="form.contact.civilite"
                        i18n="correspondant.details.civilite"
                        :readonly="!roleCorrespondant"
                        :additionalField="['raccourci']"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.contact.nom"
                        :readonly="!roleCorrespondant"
                        :label="$t('correspondant.details.nom')"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.contact.prenom"
                        :readonly="!roleCorrespondant"
                        :label="$t('correspondant.details.prenom')"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.contact.telFixe"
                        :label="$t('correspondant.details.telFixe')"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.contact.telPortable"
                        :readonly="!roleCorrespondant"
                        :label="$t('correspondant.details.telPortable')"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.contact.fax"
                        :readonly="!roleCorrespondant"
                        :label="$t('correspondant.details.fax')"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.contact.mail"
                        readonly
                        :label="$t('correspondant.details.mail')"
                      />
                    </v-flex>
                    <v-flex md8>
                      <v-text-field
                        v-model="form.contact.fonction"
                        :readonly="!roleCorrespondant"
                        :label="$t('correspondant.details.fonction')"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <v-card class="specific">
              <v-card-title class="headerCardIndigo white--text">
                <v-icon dark>card_travel</v-icon>
                <span style="margin-left: 5px">{{
                  $t('correspondant.details.etablissementRattachement')
                }}</span>
              </v-card-title>
              <v-layout row class="ma-2 pa-1">
                <v-flex md12>
                  <v-layout row>
                    <v-flex md2>
                      <v-text-field
                        :label="$t('correspondant.details.etablissementId')"
                        :value="form.etablissement ? form.etablissement.id : ''"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        :label="
                          $t('correspondant.details.etablissementRaisonSociale')
                        "
                        :value="
                          form.etablissement
                            ? form.etablissement.raisonSociale
                            : ''
                        "
                        readonly
                        class="red--text"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <v-card class="specific">
              <v-card-title class="headerCardIndigo white--text">
                <v-icon dark>business</v-icon>
                <span style="margin-left: 5px">{{
                  $t('correspondant.details.entrepriseInseeRattachement')
                }}</span>
              </v-card-title>
              <v-layout row class="ma-2 pa-1">
                <v-flex md12>
                  <v-layout row>
                    <v-flex md2>
                      <v-text-field
                        :label="$t('correspondant.details.entrepriseInseeId')"
                        :value="
                          form.entrepriseInseeExtraciem
                            ? form.entrepriseInseeExtraciem.id
                            : ''
                        "
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        :label="
                          $t(
                            'correspondant.details.entrepriseInseeRaisonSociale',
                          )
                        "
                        :value="
                          form.entrepriseInseeExtraciem
                            ? form.entrepriseInseeExtraciem.raisonSociale
                            : ''
                        "
                        readonly
                        class="red--text"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <v-card class="specific">
              <v-card-title class="headerCardIndigo white--text">
                <v-icon dark>apartment</v-icon>
                <span style="margin-left: 5px">{{
                  $t('correspondant.details.groupementRattachement')
                }}</span>
              </v-card-title>
              <v-layout row class="ma-2 pa-1">
                <v-flex md12>
                  <v-layout row>
                    <v-flex md2>
                      <v-text-field
                        :label="$t('correspondant.details.groupementId')"
                        :value="form.groupement ? form.groupement.id : ''"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        :label="
                          $t('correspondant.details.groupementRaisonSociale')
                        "
                        :value="
                          form.groupement ? form.groupement.raisonSociale : ''
                        "
                        readonly
                        class="red--text"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <v-card class="specific">
              <v-card-title class="headerCardIndigo white--text">
                <v-icon dark>mdi-alpha-r-circle</v-icon>
                <span style="margin-left: 5px">{{
                  $t('correspondant.details.role')
                }}</span>
              </v-card-title>
              <v-layout row class="ma-2 pa-1">
                <v-flex md12>
                  <v-layout row>
                    <v-flex md3>
                      <v-checkbox
                        v-model="form.roleAdmin"
                        :label="$t('correspondant.details.roleAdmin')"
                        color="primary"
                        :readonly="!roleCorrespondant"
                      />
                    </v-flex>
                    <v-flex md3>
                      <v-checkbox
                        v-model="form.roleFacturation"
                        :label="$t('correspondant.details.roleFacturation')"
                        color="primary"
                        :readonly="!roleCorrespondant"
                      />
                    </v-flex>
                    <v-flex md3>
                      <v-checkbox
                        v-model="form.roleEnvoiCourrier"
                        :label="$t('correspondant.details.roleEnvoiCourrier')"
                        color="primary"
                        :readonly="!roleCorrespondant"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </crud-detail>
    </v-fade-transition>
  </div>
</template>

<script>
import DetailCrud from '@/plugins/DetailCrud'
import moment from 'moment'
import DateFormatter from '@/plugins/mixins/DateFormatter'
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import ValidationRules from '@/plugins/mixins/ValidationRules'
import PasswordForm from '@/view/Forgot/PasswordForm'
import { validationMixin } from 'vuelidate'
import Api from '@/utils/api'
import toasted from '@/utils/toasted'

const NAMESPACE = 'correspondant'

export default {
  components: {
    passwordForm: PasswordForm,
  },
  mixins: [
    DetailCrud,
    DateFormatter,
    ErrorServeur,
    ValidationRules,
    validationMixin,
  ],

  provide() {
    return {
      namespace: NAMESPACE,
      $vroot: this.$v,
    }
  },
  data() {
    return {
      namespace: NAMESPACE,
      dialogPassword: false,
      show1: false,
      ancienMotDePasse: null,
      newPassword: null,
      confirmNewPassword: null,
      validate: false,
      messageGestionnaire: '',
      form: {
        contact: {},
        etablissement: {},
        entrepriseInseeExtraciem: {},
      },
    }
  },
  created() {},
  beforeMount() {
    let uri = ''
    if (this.$route.name == '/mescoordonnees') {
      uri = 'correspondant' + this.$route.name
    } else {
      uri = this.$route.name + '/' + this.$route.params.id
    }
    new Api(uri)
      .get()
      .then((response) => {
        this.initForm(response.body)
        this.setInitialFormDigest()
      })
      .catch(() => {
        // TODO gestion du cas d'erreur not found
      })
  },
  mounted() {},
  computed: {
    roleCorrespondant() {
      return this.$auth.hasRole('ROLE_CORRESPONDANT')
    },
  },
  watch: {},
  methods: {
    emitPassword(value) {
      this.newPassword = value
    },

    emitConfirmation(value) {
      this.confirmNewPassword = value
    },
    initForm(loaded) {
      this.form = loaded
      this.id = loaded.id
      if (loaded.contact == null) {
        this.form.contact = {}
      }
      this.$emit('isEtb', loaded.etablissement !== null)
      this.$emit(
        'isEnt',
        loaded.entrepriseInseeExtraciem !== null &&
          loaded.etablissement == null,
      )
    },
    getForms() {
      //access aux formulaire à créer
      if (this.dialogPassword) {
        return [this.$refs.passwordForm]
      }

      if (!this.dialogPassword) {
        return [this.$refs.form]
      }
    },
    cancelPassword() {
      this.dialogPassword = false
      this.ancienMotDePasse = null
      this.newPassword = null
      this.confirmNewPassword = null
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
    customSave() {
      this.validate = true
      this.$v.$touch()

      this.save()
      if (!this.$v.form.$invalid) {
        this.validate = false
      }
    },

    __validerPassword() {
      this.resetErreur()
      try {
        const ok = this.$refs.passwordForm.validate()
        return ok
      } catch (e) {
        return false
      }
    },
    changePassword() {
      //lance la validation
      const ok = this.__validerPassword()
      if (ok) {
        this.$api('/changePassword', '/oauth')
          .post({
            id: this.form.id,
            ancienMotDePasse: this.ancienMotDePasse,
            motDePasse: this.newPassword,
          })
          .then(() => {
            this.cancelPassword()
            toasted.info(this.$t('password.confirmationChange'))
          })
          .catch((errors) => {
            this.errorsHandler(errors)
          })
      }
    },
  },
  validations: {
    form: {
      contact: {},
    },
  },
}
</script>

<style scoped>
.custom-save {
  border-radius: 5px;
}

.custom-delete {
  border-radius: 5px;
}

.custom-message {
  background-color: var(--v-primary-base);
}

.v-subheader {
  background-color: var(--v-updatedGrey-base);
  color: white !important;
  border-radius: 5px;
  font-size: 13px;
}

.subheaderSpecificColor .v-subheader {
  background-color: var(--v-rose-base) !important;
}

.v-subheader .v-icon {
  color: white;
}

.custom-yellow-badge >>> .v-badge__badge {
  background-color: var(--v-yellow-base) !important;
}
</style>
<style>
.specific table.v-table tbody td {
  font-size: 11px;
}

.specific .material-icons {
  font-size: 18px;
}
.specificTableau .v-messages {
  display: none;
}

.specificTableau .v-input__slot {
  margin-bottom: 0px !important;
}

.specific .v-system-bar--window {
  height: 23px !important;
}

.specific .v-subheader {
  height: 23px !important;
}

.specificCloseBtn .v-btn--floating.v-btn--small {
  height: 33px !important;
  min-width: 0;
  padding: 0;
  width: 33px !important;
}
.specific .v-chip .v-chip__content {
  height: 26px;
}
.smallChip .v-chip {
  font-size: 10px !important;
  height: 20px;
}
.smallChip .v-chip .v-avatar {
  height: 20px !important;
  min-width: 20px;
  width: 20px !important;
}

.specific .v-avatar {
  height: 28px !important;
  width: 28px !important;
}

.reduceDialogClass {
  top: 4.10417px !important;
  position: fixed !important;
  margin: 0px !important;
  transition: none 0s ease 0s !important;
}
</style>
